import { Component, Input, OnInit } from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';
import {BsModalRef} from 'ngx-bootstrap/modal';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { ptBrLocale } from 'ngx-bootstrap/locale';
import {DateTimeService} from '../../../services/date-time.service';
import {AuthenticationService} from '../../../services/authentication.service';
defineLocale('pt-br', ptBrLocale);


@Component({
  selector: 'app-reports-filter',
  templateUrl: './interaction-filter-modal.component.html',
  styleUrls: ['./interaction-filter-modal.component.css']
})
export class InteractionFilterModalComponent implements OnInit {
  @Input() modalTitle: string;
  objInitialState;
  columnList$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>(null);
  /*locale = 'pt-br';*/

  constructor(public bsModalRef: BsModalRef, private authService: AuthenticationService) { }

  ngOnInit() {
    if (this.objInitialState) {
      this.columnList$.next(this.objInitialState.columnList);
    }
  }

  search(event) {

    if (this.objInitialState && this.objInitialState.searchMethod) {
      this.objInitialState.searchMethod(event);
    }
    // this.bsModalRef.hide();
    this.onClose();
  }

  onClose() {
    if (this.authService.checkAuthModal()) {
      this.bsModalRef.hide();
    }
  }

}
